import { DASHBOARD_ROUTES } from '@admin-platform/shared/constants';
import { Link, NavLink } from 'react-router-dom';
import { useConsent } from '../consent/ConsentContext';
import { LEGAL_ROUTES } from '../pages/legal/legal';
import { PlatformStatus } from './PlatformStatus';
import './Footer.css';

const dashboardUrl = import.meta.env.VITE_DASHBOARD_URL ?? '';

interface FooterProps {
  /** Extra class — e.g. `site-footer--home` to clear the home page's fixed ticker. */
  className?: string;
}

export function Footer({ className }: FooterProps = {}) {
  const year = new Date().getFullYear();
  const { openPreferences } = useConsent();

  return (
    <footer className={`site-footer${className ? ` ${className}` : ''}`}>
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <Link to="/" className="site-footer__brandlink">
            <svg
              className="site-footer__logo"
              viewBox="0 0 32 32"
              fill="none"
              width="28"
              height="28"
              aria-hidden
            >
              <rect width="32" height="32" rx="8" fill="#00d9a6" />
              <g transform="translate(4 6.5)">
                <path
                  d="M1.021 10.5625C4.31511 10.5625 5.13864 2.78709 6.7857 1.15015C8.43276 -0.0775511 8.84453 7.6979 10.0798 13.8364C10.9033 17.5195 12.1386 17.9287 13.3739 15.4733C15.021 12.1995 16.2563 5.24249 17.9033 4.42402C19.1386 4.01479 20.3739 8.51636 22.021 8.51636"
                  stroke="#082535"
                  strokeWidth="2.04195"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </svg>
            <span className="site-footer__brandtext">Revvly</span>
          </Link>
          <p className="site-footer__tagline">Orchestrate the flow of revenue.</p>
        </div>

        <nav className="site-footer__cols" aria-label="Footer">
          <div className="site-footer__col">
            <h2 className="site-footer__heading">Product</h2>
            <NavLink to="/" end>
              Home
            </NavLink>
            <NavLink to="/early-access" end>
              Get early access
            </NavLink>
          </div>
          <div className="site-footer__col">
            <h2 className="site-footer__heading">Resources</h2>
            <NavLink to="/docs">Docs</NavLink>
            <NavLink to="/docs/changelog">Changelog</NavLink>
            <NavLink to="/blog">Blog</NavLink>
            <NavLink to="/glossary">Glossary</NavLink>
          </div>
          <div className="site-footer__col">
            <h2 className="site-footer__heading">Account</h2>
            <a href={`${dashboardUrl}${DASHBOARD_ROUTES.login}`}>Login</a>
            <NavLink to="/early-access" end>
              Request access
            </NavLink>
          </div>
          <div className="site-footer__col">
            <h2 className="site-footer__heading">Legal</h2>
            <NavLink to={LEGAL_ROUTES.terms}>Terms of Service</NavLink>
            <NavLink to={LEGAL_ROUTES.privacy}>Privacy Policy</NavLink>
            <NavLink to={LEGAL_ROUTES.cookies}>Cookie Policy</NavLink>
            <NavLink to={LEGAL_ROUTES.subprocessors}>Sub-processors</NavLink>
            <button type="button" className="site-footer__linkbtn" onClick={openPreferences}>
              Cookie settings
            </button>
          </div>
        </nav>
      </div>

      <div className="site-footer__bar">
        <span>© {year} AcceleratorApp Limited. All rights reserved.</span>
        <PlatformStatus />
      </div>
    </footer>
  );
}
